import { render, staticRenderFns } from "./DataTableConsultaComp.vue?vue&type=template&id=2991b67e&scoped=true"
import script from "./DataTableConsultaComp.vue?vue&type=script&lang=js"
export * from "./DataTableConsultaComp.vue?vue&type=script&lang=js"
import style0 from "./DataTableConsultaComp.vue?vue&type=style&index=0&id=2991b67e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2991b67e",
  null
  
)

export default component.exports